import { KitchenAreaContainer, LivingAreaContainer, RoomAreaContainer, TotalAreaContainer } from '../containers';

export const AREA_FILTERS_MAP = {
  general: TotalAreaContainer,
  kitchen: KitchenAreaContainer,
  living: LivingAreaContainer,
  room: RoomAreaContainer,
};
